export default {
    props: {
        maxDecimal: {
            type: Number,
            default: 2
        },
        opacity: Number,
        yKeys: Array,
        xKey: String,
        xAxis: Boolean,
        yAxis: Boolean,
        xLabel: Boolean,
        yLabel: Boolean,
        animation: Boolean,
        xGrid: {
            type: Number,
            default: 0
        },
        yGrid: {
            type: Number,
            default: 0
        },
        width: Number,
        height: Number,
        data: {
            type: Array,
            default: () => []
        },
        labelRotate: {
            type: Number,
            default: -45
        },
        labelColor: {
            type: String,
            default: '#999999'
        },
        padding: {
            type: Number,
            default: 20
        },
        marginLeft: {
            type: [Number, String],
            default: 'auto',
            validator: function (value) {
                if (typeof value === 'string') {
                    return value === 'auto'
                } else {
                    return typeof value === 'number'
                }
            }
        },
        tickPadding: {
            type: Number,
            default: 10
        },
        tickSize: {
            type: Number,
            default: 0.5
        },
        strokeColor: {
            type: String,
            default: 'rgba(190, 190, 190, 0.8)'
        },
        strokeWidth: {
            type: Number,
            default: 1
        },
        minimumMax: {
            type: Number,
            default: 1
        },
        maximumMax: Number,
        legendSize: {
            type: Number,
            default: 10
        },
        legendPadding: {
            type: Number,
            default: 2
        },
        legendDirection: {
            type: String,
            validator: function (value) {
                return !!value || (value && ['left-top', 'left-bottom', 'right-top', 'right-bottom'].includes(value))
            }
        },
        gradients: Object,
        gradient: {
            type: Array,
            default: () => ['#fff']
        },
        gradientDirection: {
            type: String,
            default: 'top'
        }
    }
}
